export default {
  selectPlaceHolder1: '请选择',
  datePlaceHolder1: '选择日期',
  confirm: '确认',
  inputPlaceholder1: '在此输入',
  noData: '无数据',
  noMatch: '未能匹配',
  success: '成功',
  search1: '搜索',
  deleted1: '删除',
  defineBtn: '确定',
  edit1: '编辑',
  notice: '提示',
  success2: '操作成功',
  loading1: '加载中...',
  cancel1: '取消',
  update1: '更新',
  update2: '更新完成',
  yes: '是',
  no: '否',
  region: '国别',
  reset: '重置',
  submit: '提交',
  login: '登录',
  chooseStore: '请选择店铺',
  uploadImage: '上传图片',
  upload: '上传',
  export: '导出订单'
}
